import React from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import MaterialModal from "../MaterialModal";
import { hideModal } from "../../../actions/actionCreators";
import { requestLayoutDelete2 } from "../../../actions/exportLayoutActions2";
import { notifyError } from "../../../actions/notifyActions";
import withModal from "../withModal";

const LayoutDeleteModal = ({ modalProps, isOpen }) => {
    const dispatch = useDispatch();
    const enabledFeatures = useSelector(state => state.session.enabledFeatures || []);
    const roles = useSelector(state => state.session.roles || []);

    const hide = () => dispatch(hideModal("LAYOUT_DELETE"));

    const deleteLayout = () => {
        const isAdmin = roles.includes("Super Admin") || roles.includes("Experian Admin");

        if (isAdmin || enabledFeatures.includes("manage-layouts")) {
            dispatch(requestLayoutDelete2(parseInt(modalProps.layout.LayoutID)));
        } else {
            dispatch(notifyError("Unable to delete layouts for this company."));
        }
        hide();
    };
    return (
        <MaterialModal
            id="delete-layout"
            isOpen={isOpen}
            title="Delete Layout"
            primaryButtonText="Delete"
            onClose={hide}
            onPrimaryButtonRequest={deleteLayout}
            showPrimaryButton={true}
            isPrimaryButtonDisabled={false}
        >
            <div>
                Confirm deletion of layout: <b>{modalProps.layout != null ? modalProps.layout.LayoutName : null}</b>
            </div>
        </MaterialModal>
    );
};
LayoutDeleteModal.propTypes = {
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
    // Injected from Redux (ActionCreators)
    hideModal: PropTypes.func,
};

export default withModal(LayoutDeleteModal, "LAYOUT_DELETE");
